
	import {
		Vue,
		Component,
		Emit,
		Prop
	} from "vue-property-decorator";

	@Component
	export default class TeachingMaterial_home extends Vue {
		openKeys: Array < string > = [];

		titleClick(): void {};
		handleClick(): void { 
		};
		onOpenChange():void{};
		leafNodeClick(e:any):void{
			let path = e.domEvent.srcElement.dataset.tohref;
			this.$router.push({
				path:path,
				query:{
					
				}
			});
		};
	};
